import { sum } from 'lodash-es'

import { useCategoryName, useTournamentPlayersCountName } from '../../Queries/Dictionaries'
import { navigateToTournamentPage } from '../../Scenes/navigators'
import { ArchiveRestoreEvent } from '../_common/ArchiveEvent/ArchiveRestoreEvent'
import { EventCard } from '../_common/EventCard/EventCard'
import { ArchiveRestoreTournamentModal } from './ArchiveRestoreTournamentModal'
import { TOURNAMENT_OWNER_AVATAR } from './constants'
import { TournamentMobileStepper, TournamentStepper } from './TournamentStepper'

const TournamentEventCard = ({ event, disableStepper }) => {
  const categoryName = useCategoryName(event?.category_id)
  const playersCountName = useTournamentPlayersCountName(event?.players_counts)

  if (!event) return null

  const eventId = event.id
  const title = event.title
  const prize = sum(event.prizes)
  const link = navigateToTournamentPage(eventId, true)
  const ownerName = 'ForgeHub'
  const stepper = disableStepper ? null : <TournamentStepper tournament={event} />
  const mobileStepper = disableStepper ? null : <TournamentMobileStepper tournament={event} />

  const renderRestoreEvent = () =>
    event.time_archived ? (
      <ArchiveRestoreEvent
        renderRestoreModal={(props) => (
          <ArchiveRestoreTournamentModal
            eventId={eventId}
            eventTypeName="tournament"
            withEdit
            {...props}
          />
        )}
      />
    ) : null

  return (
    <EventCard
      eventId={eventId}
      eventType="tournament"
      title={title}
      backgroundSrc={event.background}
      categoryName={categoryName}
      playersCountName={playersCountName}
      prize={prize}
      link={link}
      ownerName={ownerName}
      ownerAvatarSrc={TOURNAMENT_OWNER_AVATAR}
      stepper={stepper}
      mobileStepper={mobileStepper}
      renderRestoreEvent={renderRestoreEvent}
    />
  )
}

export { TournamentEventCard }
